module.exports = __webpack_public_path__ + "static/img/sponsors_low.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sponsors_low.png
// module id = Pwq4
// module chunks = 0